import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BannersService } from '../../services/banners.service';
import { Banner } from '../../interfaces/banner';

@Component({
  selector: 'app-banner-carousel-b',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './banner-carousel-b.component.html',
  styleUrls: ['./banner-carousel-b.component.scss'],
})
export class BannerCarouselBComponent implements OnInit, OnDestroy {
  banners: Banner[] = [];
  currentIndex = 0;
  isLoading = true;
  isHovered = false;
  private autoplayInterval: any;
  private isBrowser: boolean;

  constructor(
    private bannersService: BannersService,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.bannersService.getActiveBanners().subscribe({
      next: (banners) => {
        this.banners = banners;
        this.isLoading = false;
        if (this.banners.length > 1) this.startAutoplay();
      },
      error: () => { this.isLoading = false; }
    });
  }

  ngOnDestroy(): void { this.stopAutoplay(); }

  startAutoplay() {
    if (!this.isBrowser) return;
    this.autoplayInterval = setInterval(() => { if (!this.isHovered) this.next(); }, 5500);
  }

  stopAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval);
  }

  next() { this.currentIndex = (this.currentIndex + 1) % this.banners.length; }
  prev() { this.currentIndex = (this.currentIndex - 1 + this.banners.length) % this.banners.length; }

  goTo(index: number) {
    this.currentIndex = index;
    this.stopAutoplay();
    this.startAutoplay();
  }

  onBannerClick(banner: Banner) {
    switch (banner.linkType) {
      case 'event':    this.router.navigate(['/event', banner.linkValue]); break;
      case 'brewery':  this.router.navigate(['/brewery', banner.linkValue]); break;
      case 'new-hop':  this.router.navigate(['/new-hop']); break;
      case 'external': if (this.isBrowser && banner.linkValue) window.open(banner.linkValue, '_blank'); break;
    }
  }

  isClickable(banner: Banner): boolean { return banner.linkType !== 'none'; }
}
